import { useEffect, useState } from 'react';

/** Viewport estreito (mobile) — alinhado ao breakpoint `md` do Tailwind (768px). */
export function useCompactViewport(): boolean {
  const [compact, setCompact] = useState(() =>
    typeof window !== 'undefined' ? window.matchMedia('(max-width: 767px)').matches : false
  );

  useEffect(() => {
    const media = window.matchMedia('(max-width: 767px)');
    const onChange = () => setCompact(media.matches);
    media.addEventListener('change', onChange);
    return () => media.removeEventListener('change', onChange);
  }, []);

  return compact;
}
